import React, { ReactNode, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Spinner, Center } from '@chakra-ui/react';

interface ProtectedRouteProps {
  children: ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && !user) {
      // Hard redirect — / is the marketing landing (served by the backend or
      // proxied in dev), not a React Router route.
      window.location.replace('/');
    }
  }, [loading, user]);

  if (loading || !user) {
    return (
      <Center h="200px">
        <Spinner size="lg" color="var(--accent)" />
      </Center>
    );
  }

  return <>{children}</>;
};